import { useQuery } from "react-query";
import { apiConfig } from "../config/apiConfig";
import apiService from "../service/apiService";
import { useCookie } from "./useCookie";

export function useGetRidesByIds(rideIds: string[]) {
  const { token } = useCookie("vToken");

  return useQuery(
    ["selectedRides", rideIds],
    async () => {
      if (!rideIds.length) return { items: [] };

      const endpoint = apiConfig.rides.getByIds(rideIds.join(","));
      const response = await apiService.MakeGetRequest(endpoint, token);

      return response.items;
    },
    {
      enabled: rideIds.length > 0,
    },
  );
}
